var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "external-assets-modal",
        title: _vm.modalTitle,
        size: "lg",
        "ok-only": "",
        "ok-disabled": !_vm.selectedAssets.length,
      },
      on: {
        shown: _vm.onModalShown,
        hidden: _vm.onModalHidden,
        ok: _vm.handleOkClick,
      },
    },
    [
      _c(
        "div",
        { staticClass: "external-assets-container" },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c("div", { staticClass: "search-container flex-grow-1 mr-3" }, [
                _c("div", { staticClass: "search-input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery",
                      },
                    ],
                    staticClass: "search-input",
                    attrs: { type: "text", placeholder: "Search..." },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.performSearch.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchQuery = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "search-icon",
                      attrs: { width: "13", height: "13" },
                    },
                    [
                      _c("use", {
                        attrs: { href: "/img/icons/sprite.svg#search-big" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.searchQuery
                    ? _c(
                        "button",
                        {
                          staticClass: "clear-search-btn",
                          on: { click: _vm.clearSearch },
                        },
                        [_c("i", { staticClass: "cil-x" })]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.assets.length || _vm.isLoading
            ? _c(
                "div",
                [
                  _vm.isLoading
                    ? [
                        _c(
                          "div",
                          { staticClass: "assets-grid" },
                          _vm._l(_vm.pageSize, function (n) {
                            return _c(
                              "div",
                              {
                                key: n,
                                staticClass: "w-100 h-100",
                                staticStyle: { "min-height": "167px" },
                              },
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "100%", height: "88%" },
                                }),
                                _vm._v(" "),
                                _c("b-skeleton"),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    : [
                        _vm.isSearchActive &&
                        _vm.assets.length &&
                        _vm.wasEnterPressed
                          ? _c(
                              "b-alert",
                              {
                                staticClass: "mb-3",
                                attrs: { show: "", variant: "info" },
                              },
                              [
                                _vm._v(
                                  "\n          Found " +
                                    _vm._s(_vm.totalCount) +
                                    " result" +
                                    _vm._s(_vm.totalCount > 1 ? "s" : "") +
                                    ' for "' +
                                    _vm._s(_vm.searchQuery) +
                                    '"\n        '
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSearchActive &&
                        !_vm.assets.length &&
                        !_vm.isLoading
                          ? _c(
                              "b-alert",
                              {
                                staticClass: "mb-3",
                                attrs: { show: "", variant: "warning" },
                              },
                              [
                                _vm._v(
                                  '\n          No results found for "' +
                                    _vm._s(_vm.searchQuery) +
                                    '"\n        '
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "assets-grid" },
                          _vm._l(_vm.assets, function (asset) {
                            return _c("GridItem", {
                              key: asset.id,
                              attrs: {
                                item: asset,
                                "is-selected": _vm.isSelected(asset),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSelectAsset(asset)
                                },
                              },
                            })
                          }),
                          1
                        ),
                      ],
                ],
                2
              )
            : _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                _vm._v("\n      No external assets available\n    "),
              ]),
          _vm._v(" "),
          _vm.selectedAssets.length
            ? _c("div", { staticClass: "selection-summary" }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    _vm._s(_vm.selectedAssets.length) +
                      " asset" +
                      _vm._s(_vm.selectedAssets.length > 1 ? "s" : "") +
                      " selected"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center align-items-center" },
            [
              _c("b-pagination", {
                attrs: {
                  "per-page": _vm.pageSize,
                  "total-rows": _vm.totalCount,
                  disabled: _vm.isLoading,
                },
                on: { change: _vm.onChangePage },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }